import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { ProductImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductImage";
import { ImageContainer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/styled";
import { useAssignSettingUpdateSaleColorCopy, useSettingUpdateSaleColorCopy } from "@faire/retailer-visitor-shared/settings/useSettingUpdateSaleColorCopy";
import { localNum } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackCoreCollectionsCollectionTileClick } from "@faire/web-api--source/events/coreCollections/click/collectionTile";
import { trackCoreCollectionsProductBasedCollectionTileView } from "@faire/web-api--source/events/coreCollections/view/productBasedCollectionTile";
import { ICollectionTile } from "@faire/web-api--source/indigofair/data/ICollectionTile";
import React, { useEffect, useState } from "react";
import { CollectionImpression } from "@faire/retailer/components/CollectionDiscovery/config";
import { getProductBasedCollectionLinkTo } from "@faire/retailer/features/MarketplaceItems/collectionUtils";
import { CollectionTileClickImpressionContext } from "@faire/retailer/hooks/CollectionTileImpression/CollectionTileClickImpressionContext";
import { useCollectionTileViewImpression } from "@faire/retailer/hooks/CollectionTileImpression/useCollectionTileViewImpression";
import { bpsToPercent } from "@faire/retailer/lib/bpsToDecimalAndPercent";
export var CollectionTile = function(param) {
    var collection = param.collection, imageDimension = param.imageDimension, source = param.source, onClick = param.onClick;
    var linkTo = useCollectionLinkTo(collection);
    var itemsCountNumber = useCollectionItemsCount(collection);
    var _React_useContext = React.useContext(CollectionTileClickImpressionContext), contextToken = _React_useContext.contextToken, requestId = _React_useContext.requestId, screenContext = _React_useContext.screenContext, containerContext = _React_useContext.containerContext;
    var onClickEvent = function() {
        var _collection_collection_promo;
        onClick === null || onClick === void 0 ? void 0 : onClick();
        var _collection_product_based_collection_token, _collection_collection_promo_brand_promo_collection_token;
        trackCoreCollectionsCollectionTileClick(contextToken !== null && contextToken !== void 0 ? contextToken : "", (_collection_product_based_collection_token = collection.product_based_collection_token) !== null && _collection_product_based_collection_token !== void 0 ? _collection_product_based_collection_token : "", requestId !== null && requestId !== void 0 ? requestId : "", screenContext !== null && screenContext !== void 0 ? screenContext : ICollectionTile.Screen.SCREEN_UNKNOWN, containerContext !== null && containerContext !== void 0 ? containerContext : ICollectionTile.ScreenContainer.SCREEN_CONTAINER_UNKNOWN, (_collection_collection_promo_brand_promo_collection_token = (_collection_collection_promo = collection.collection_promo) === null || _collection_collection_promo === void 0 ? void 0 : _collection_collection_promo.brand_promo_collection_token) !== null && _collection_collection_promo_brand_promo_collection_token !== void 0 ? _collection_collection_promo_brand_promo_collection_token : "");
    };
    var _collection_product_based_collection_token;
    var trackCollectionTileProps = useCollectionTileViewImpression({
        collectionToken: (_collection_product_based_collection_token = collection.product_based_collection_token) !== null && _collection_product_based_collection_token !== void 0 ? _collection_product_based_collection_token : ""
    });
    var visibleRef = useDoActionWhenVisible(function() {
        var _collection_collection_promo;
        var _collection_product_based_collection_token, _collection_collection_promo_brand_promo_collection_token;
        trackCoreCollectionsProductBasedCollectionTileView((_collection_product_based_collection_token = collection.product_based_collection_token) !== null && _collection_product_based_collection_token !== void 0 ? _collection_product_based_collection_token : "", source !== null && source !== void 0 ? source : CollectionImpression.COLLECTION_TILE, (_collection_collection_promo_brand_promo_collection_token = (_collection_collection_promo = collection.collection_promo) === null || _collection_collection_promo === void 0 ? void 0 : _collection_collection_promo.brand_promo_collection_token) !== null && _collection_collection_promo_brand_promo_collection_token !== void 0 ? _collection_collection_promo_brand_promo_collection_token : "");
    });
    var _collection_name;
    return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
        to: linkTo !== null && linkTo !== void 0 ? linkTo : "",
        onClick: onClickEvent,
        "data-test-id": "collection-tile"
    }, trackCollectionTileProps), {
        ref: function(element) {
            var _trackCollectionTileProps_ref;
            trackCollectionTileProps === null || trackCollectionTileProps === void 0 ? void 0 : (_trackCollectionTileProps_ref = trackCollectionTileProps.ref) === null || _trackCollectionTileProps_ref === void 0 ? void 0 : _trackCollectionTileProps_ref.call(trackCollectionTileProps, element);
        },
        children: /*#__PURE__*/ _jsxs(Column, {
            ref: visibleRef,
            children: [
                /*#__PURE__*/ _jsx(ImageContainer, {
                    children: /*#__PURE__*/ _jsx(ProductImage, {
                        image: collection.image,
                        imageDimension: imageDimension,
                        showVerticalImagery: false,
                        alt: (_collection_name = collection.name) !== null && _collection_name !== void 0 ? _collection_name : ""
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansMedium",
                    truncate: true,
                    children: collection.name
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.subdued,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Mq/N6J",
                        defaultMessage: [
                            {
                                type: 6,
                                value: "itemsCountNumber",
                                options: {
                                    one: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " item"
                                            }
                                        ]
                                    },
                                    other: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " items"
                                            }
                                        ]
                                    }
                                },
                                offset: 0,
                                pluralType: "cardinal"
                            }
                        ],
                        values: {
                            itemsCountNumber: itemsCountNumber
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(CollectionDiscountTag, {
                    collection: collection
                })
            ]
        })
    }));
};
var CollectionDiscountTag = function(param) {
    var collection = param.collection;
    var _collection_active_display_promo, _collection_collection_promo;
    var showFreeDisplayTag = ((_collection_active_display_promo = collection.active_display_promo) === null || _collection_active_display_promo === void 0 ? void 0 : _collection_active_display_promo.type) === "FREE_DISPLAY";
    var showDiscountPercentageTag = !!((_collection_collection_promo = collection.collection_promo) === null || _collection_collection_promo === void 0 ? void 0 : _collection_collection_promo.discount_bps);
    var shouldUpdateSaleColorCopy = useSettingUpdateSaleColorCopy();
    var assignUpdateSaleColorCopy = useAssignSettingUpdateSaleColorCopy();
    var promoColor = shouldUpdateSaleColorCopy ? SERRANO : Decorative.shade.orange;
    useEffect(function() {
        if (showFreeDisplayTag || showDiscountPercentageTag) {
            assignUpdateSaleColorCopy();
        }
    }, [
        showFreeDisplayTag,
        showDiscountPercentageTag,
        assignUpdateSaleColorCopy
    ]);
    if (showFreeDisplayTag && showDiscountPercentageTag) {
        var _collection_collection_promo1;
        var _collection_collection_promo_discount_bps;
        return /*#__PURE__*/ _jsx(Typography, {
            color: promoColor,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "moU1to",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Free display + "
                    },
                    {
                        type: 1,
                        value: "discountPercentageNumber"
                    },
                    {
                        type: 0,
                        value: "% off"
                    }
                ],
                values: {
                    discountPercentageNumber: bpsToPercent((_collection_collection_promo_discount_bps = (_collection_collection_promo1 = collection.collection_promo) === null || _collection_collection_promo1 === void 0 ? void 0 : _collection_collection_promo1.discount_bps) !== null && _collection_collection_promo_discount_bps !== void 0 ? _collection_collection_promo_discount_bps : 0)
                }
            })
        });
    }
    if (showDiscountPercentageTag) {
        var _collection_collection_promo2;
        var _collection_collection_promo_discount_bps1;
        return /*#__PURE__*/ _jsx(Typography, {
            color: promoColor,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "YtA3nD",
                defaultMessage: [
                    {
                        type: 1,
                        value: "discountPercentageNumber"
                    },
                    {
                        type: 0,
                        value: "% off"
                    }
                ],
                values: {
                    discountPercentageNumber: bpsToPercent((_collection_collection_promo_discount_bps1 = (_collection_collection_promo2 = collection.collection_promo) === null || _collection_collection_promo2 === void 0 ? void 0 : _collection_collection_promo2.discount_bps) !== null && _collection_collection_promo_discount_bps1 !== void 0 ? _collection_collection_promo_discount_bps1 : 0)
                }
            })
        });
    }
    if (showFreeDisplayTag) {
        return /*#__PURE__*/ _jsx(Typography, {
            color: promoColor,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "9s8Hi2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Free display"
                    }
                ]
            })
        });
    }
    return null;
};
var useCollectionLinkTo = function(collection) {
    var _useState = _sliced_to_array(useState(getProductBasedCollectionLinkTo(collection.product_based_collection_token)), 2), linkTo = _useState[0], setLinkTo = _useState[1];
    useEffect(function() {
        setLinkTo(getProductBasedCollectionLinkTo(collection.product_based_collection_token));
    }, [
        collection.product_based_collection_token
    ]);
    return linkTo;
};
var useCollectionItemsCount = function(collection) {
    var _collection_total_items;
    var _useState = _sliced_to_array(useState(localNum((_collection_total_items = collection.total_items) !== null && _collection_total_items !== void 0 ? _collection_total_items : 0)), 2), count = _useState[0], setCount = _useState[1];
    useEffect(function() {
        var _collection_total_items;
        setCount(localNum((_collection_total_items = collection.total_items) !== null && _collection_total_items !== void 0 ? _collection_total_items : 0));
    }, [
        collection.total_items
    ]);
    return count;
};
